document.addEventListener('click', (e) => {
    const showButton = e.target.closest('[data-dialog-show]');
    if (showButton) {
        const target = document.querySelector(`#${showButton.dataset.dialogShow}`);
        if (e.target.href || e.target.closest('a[href]')) {
            e.preventDefault();
        }

        target.showModal();
        document.querySelector('div#main-content').classList.add('overflow-hidden');
    }

    const closeButton = e.target.closest('[data-dialog-close]');
    if (closeButton) {
        const target = document.querySelector(`#${closeButton.dataset.dialogClose}`);
        e.preventDefault();
        target.close();
        document.querySelector('div#main-content').classList.remove('overflow-hidden');
    }
});
